import React, { useState, useContext, useEffect } from "react"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Table,
} from "reactstrap"
import { Link } from "react-router-dom"
import {formatNumberWithCommas} from '../../common/utility'
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { WishlistContext } from "context/wishlistContext"
import ToastDialog from "components/Common/ToastDialog"
import { CartContext } from "context/cartContext"
import { isError } from "lodash"

const EcommerceWishlist = () => {
  document.title = "Wishlist | DMS"
  const [productList, setproductList] = useState([])
  const {
    getWishlistData,
    removeItemFromWishlist,
  } = useContext(WishlistContext)
  const { addItemToCart, getCartData } = useContext(CartContext)
  const [toastInfo, setToastInfo] = useState({ showToast: false })
  const [isEmpty, setIsEmpty] = useState(false)
  const [hasError, setHasError] = useState([]);


  useEffect(() => {
    fetchWishlist()
  }, [])

  const fetchWishlist = async () => {
    try {
      let res = await getWishlistData()
      const { data: responseData } = res
      if (responseData.data.length === 0) {
        setIsEmpty(true)
      }
      console.log(responseData.data)
      setproductList(responseData.data)
    } catch (e) {
      setToastInfo({
        message: e.message,
        showToast: true,
        role: "error",
      })
    }
  }

  const handleDelete = async id => {
    try {
      let res = await removeItemFromWishlist({ productId: id })
      const { message } = res
      setToastInfo({
        message: message,
        showToast: true,
        role: "success",
      })
      fetchWishlist()
    } catch (err) {
      setToastInfo({
        message: err.message,
        showToast: true,
        role: "error",
      })
    }
  }

  const handleAddToCart = async (id,lotSize) => {
    try {
      await removeItemFromWishlist({ productId: id })
      await addItemToCart({
        productId: id,
        quantity: lotSize || 1,
      })
      setToastInfo({
        message: "Product added to cart successfully",
        showToast: true,
        role: "success",
      })
      getCartData()
      fetchWishlist()
    } catch (e) {
      setToastInfo({
        message: e.message,
        showToast: true,
        role: "error",
      })
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Ecommerce" breadcrumbItem="Wishlist" />
          {!isEmpty ? (
            <Row>
              <Col xl={12}>
                <Card>
                  <CardBody>
                    <div className="table-responsive">
                      <Table className="table align-middle mb-0 table-nowrap">
                        <thead className="table-light">
                          <tr>
                            <th>Product</th>
                            <th>Product Name</th>
                            <th>Price</th>
                            <th colSpan="2">Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {productList.map((product, index) => {
                            let imgUrl = product?.product.productImages?.find(
                              i => i.image.primary === true
                            )
                            return (
                              <tr key={product.product.id}>
                                <td>
                                <div className={imgUrl?.image?.paths?.original && !hasError[index] ? "td-product-img" : "td-no-product-img"}>
                                      <Link
                                        to={
                                          "/customer/product-detail/" +
                                          product?.product?.id
                                        }
                                        className="text-dark"
                                      >
                                        {
                                          (imgUrl?.image?.paths?.original && !hasError[index]) ? (
                                            <img
                                              src={
                                                process.env.REACT_APP_IMAGE_URL +
                                                imgUrl?.image?.paths?.original
                                              }
                                              alt=""
                                              style={{
                                                cursor: "pointer",
                                                width: '100%',
                                                height: '4.5rem'

                                              }}
                                              onError={(e) => {
                                                e.target.onerror = null; // Prevents infinite looping if default image also fails to load
                                                e.target.src = '/no-image.png';
                                                e.target.style.width = '2.5rem';
                                                e.target.style.height = '2.5rem';
                                                setHasError(prevState => {
                                                  const newState = [...prevState];
                                                  newState[index] = true;
                                                  return newState;
                                                });
                                              }}
                                              className="img-fluid d-block"
                                            />
                                          ) : (
                                            <img
                                              src={
                                                "/no-image.png"
                                              }
                                              alt=""
                                              className="img-fluid mx-auto d-block"
                                              style={{
                                                // height: "10rem",
                                                cursor: "pointer",
                                                width: '2rem'
                                              }}
                                            />
                                          )
                                        }
                                      </Link>
                                    </div>
                                </td>
                                <td>
                                  <h5 className="font-size-14 text-truncate">
                                    <Link
                                      to={
                                        "/customer/product-detail/" +
                                        product.product.id
                                      }
                                      className="text-dark"
                                    >
                                      {product.product.productName}
                                    </Link>
                                  </h5>
                                </td>
                                <td>{formatNumberWithCommas(product.product.sellingPrice)}</td>
                                <td>
                                  <Link
                                    to="#"
                                    onClick={() => {
                                      handleAddToCart(product.product.id, +product?.product?.lotSize)
                                    }}
                                    
                                    className="action-icon"
                                    title="Add to Cart"
                                  >
                                    {" "}
                                    <i className="bx bx-cart-alt font-size-18" />
                                  </Link>

                                  <Link
                                    to="#"
                                    onClick={() => {
                                      handleDelete(product.product.id)
                                    }}
                                    className="action-icon text-danger"
                                    title="Delete from wishlist"
                                  >
                                    {" "}
                                    <i className="mdi mdi-trash-can font-size-18" />
                                  </Link>
                                </td>
                              </tr>
                            )
                          })}
                        </tbody>
                      </Table>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          ) : (
            <>
              <div style={{ textAlign: "center", marginTop: "50px" }}>
                <h2>Your Wishlist is Empty</h2>
                <p>
                  Looks like you haven't added any products to your wishlist
                  yet.
                </p>
                <img
                  src="/wishlist.svg"
                  alt="Empty Cart"
                  style={{ width: "300px", height: "300px", marginTop: "20px" }}
                />
                <p>
                  <a href="/customer/listProduct">Browse Products</a> to find
                  items to add to your wishlist.
                </p>
              </div>
            </>
          )}
        </Container>
      </div>
      <ToastDialog
        message={toastInfo.message}
        showToast={toastInfo.showToast}
        role={toastInfo.role}
        onCloseFn={() => setToastInfo({ showToast: false })}
      />
    </React.Fragment>
  )
}

export default EcommerceWishlist
